import { Route, Routes } from "react-router";
import { NotFound } from "../../app/pages/NotFound";
import { WILDCARD_ROUTE } from "../../common/constants";
import { TopAgentType } from "../../common/enums";
import { Permission } from "../../common/security/enums";
import PageWithPermission from "../auth/components/PageWithPermission";
import FinancialMediationCreateContainer from "./containers/FinancialMediationCreateContainer";
import FinancialMediationDetailContainer from "./containers/FinancialMediationDetailContainer";
import { FINANCIAL_MEDIATION_ROUTE_PATHS } from "./paths";

const routes = () => (
  <Routes>
    <Route
      path={FINANCIAL_MEDIATION_ROUTE_PATHS.detail.path}
      element={
        <PageWithPermission
          component={<FinancialMediationDetailContainer />}
          permissions={[
            Permission.INSURANCE_READ,
            Permission.LOAN_READ,
            Permission.DEPOSIT_READ,
            Permission.SECOND_PILLAR_READ,
            Permission.THIRD_PILLAR_READ,
          ]}
          allowedTopAgents={[
            TopAgentType.GENERIC,
            TopAgentType.JNP,
            TopAgentType.SWELL,
            TopAgentType.REMARCO,
            TopAgentType.FINGO,
          ]}
          anyPermission
        />
      }
    />

    <Route
      path={FINANCIAL_MEDIATION_ROUTE_PATHS.create.path}
      element={
        <PageWithPermission
          component={<FinancialMediationCreateContainer />}
          permissions={[
            Permission.INSURANCE_CREATE,
            Permission.LOAN_CREATE,
            Permission.DEPOSIT_CREATE,
            Permission.SECOND_PILLAR_CREATE,
            Permission.THIRD_PILLAR_CREATE,
          ]}
          anyPermission
          allowedTopAgents={[
            TopAgentType.GENERIC,
            TopAgentType.JNP,
            TopAgentType.SWELL,
            TopAgentType.REMARCO,
            TopAgentType.FINGO,
          ]}
        />
      }
    />

    <Route path={WILDCARD_ROUTE} element={<NotFound />} />
  </Routes>
);

export default routes;
